

export const  crewdata = [
    {
        position: 'Commander',
        name: 'Douglas Hurley',
        description: 'Douglas Gerald Hurley is an American engineer, former Marine Corps pilot and former NASA astronaut. He launched into space the third time as commander of Crew Dragon Demo-2.',
        crewImage: 'https://res.cloudinary.com/soyousay/image/upload/v1657446651/space_tours/Crew/image-douglas-hurley_suej5w.webp',
        alt: 'Douglas Hurley',
    },
    {
        position: 'Flight Engineer',
        name: 'Anousheh Ansari',
        description: 'Anousheh Ansari is an Iranian American engineer and co-founder of Prodea Systems. Ansari was the fourth self-funded space tourist, the first self-funded woman to fly to the ISS, and the first Iranian in space.',
        crewImage: 'https://res.cloudinary.com/soyousay/image/upload/v1657446651/space_tours/Crew/image-anousheh-ansari_mc3dsj.webp',
        alt: 'Anousheh Ansari',
    },
    {
        position:'Pilot' ,
        name: 'Victor Glover',
        description: 'Pilot on the first operational flight of the SpaceX Crew Dragon to the International Space Station. Glover is a commander in the U.S. Navy where he pilots an F/A-18.He was a crew member of Expedition 64, and served as a station systems flight engineer.',
        crewImage: 'https://res.cloudinary.com/soyousay/image/upload/v1657446652/space_tours/Crew/image-victor-glover_rhux7h.webp',
        alt: 'Victor Glover',
    },
    {
        position: 'Mission Specialist',
        name: 'Mark Shuttleworth',
        description: 'Mark Richard Shuttleworth is the founder and CEO of Canonical, the company behind the Linux-based Ubuntu operating system. Shuttleworth became the first South African to travel to space as a space tourist.',
        crewImage: 'https://res.cloudinary.com/soyousay/image/upload/v1657446652/space_tours/Crew/image-mark-shuttleworth_ejidge.webp',
        alt: 'Mark Shuttleworth',
    }

]